import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../components/auth/AuthProvider';

export function ProtectedRoute() {
  const { user, session, loading } = useAuth();
  
  // Check if user is truly authenticated (has both user and valid session)
  const isAuthenticated = user && session;

  // Show loading indicator only during initial authentication check
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full"></div>
        <p className="ml-3 text-sm text-gray-500">Verifying authentication...</p>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Render child routes if authenticated
  return <Outlet />;
}
